import { createAction, props } from '@ngrx/store';
import { Quote } from '@lockton-apps/shared/interfaces';

export enum QuoteAddonsActionsTypes {
  Init = '[Quote Addons Page] Initialised',
  QuoteSentToClient = '[Quote Options Page] Quote Sent To Client',
  QuoteAccepted = '[Quote Options Page] Quote Accepted',
}

export const QuoteAddonsActions = {
  init: createAction(QuoteAddonsActionsTypes.Init),
  quoteSentToClient: createAction(
    QuoteAddonsActionsTypes.QuoteSentToClient,
    props<{ quote: Quote }>()
  ),
  quoteAccepted: createAction(
    QuoteAddonsActionsTypes.QuoteAccepted,
    props<{ quote: Quote }>()
  ),
};
